import { createContext } from 'react';

export const MassUpdateContext = createContext({});
